module.exports = __webpack_public_path__ + "media/images/fallback/product_square_thumb-df966b1ff839260e051992fe465b42db.webp";